import React from 'react'
import ExportCaseFields from './ExportCaseFields'
import './dashboard.scss'
import Layout from '../../layouts/Layout'


export default function Dashboard() {
    return (
        <Layout title={'Dashboard'}>
            <div className='dashboard-container'>
                <ExportCaseFields />
            </div>
        </Layout>
    )
}
